import contentPageApi from './api';

export * from './api';
export default contentPageApi;
